import React from 'react'
import { useNProgress } from '@tanem/react-nprogress'
import classNames from 'classnames'

type Props = {
  isRouteChanging: boolean
}

const ProgressBar = ({ isRouteChanging }: Props) => {
  const { animationDuration, isFinished, progress } = useNProgress({
    isAnimating: isRouteChanging,
  })

  const progressPercentage = progress * 100

  return (
    <div
      className={classNames({ 'a-pulse u-bg-blue': !isFinished })}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '4px',
        width: isFinished ? 0 : `${progressPercentage}%`,
        transition: `width ${animationDuration}ms linear`,
        zIndex: 100,
      }}></div>
  )
}

export default ProgressBar
